import { IGraph } from "./IGraph";
import { IGraphOptions } from "../lib/types/selectedFilters";

import HC_exporting from "highcharts/modules/exporting";
import HC_clusters from "highcharts/modules/marker-clusters";
import * as Highcharts from "highcharts";
import HC_map from "highcharts/modules/map";
import worldMap from "@highcharts/map-collection/custom/world.geo.json";
import * as Guidelines from "../../common/lib/types/graphs/colors";
import { UserEndPoint } from "../lib/air-api-constant";
import proj4 from "proj4";

HC_map(Highcharts);
HC_exporting(Highcharts);
// HC_clusters(Highcharts);

export class TntWorldMap implements IGraph {
    chart: any = undefined;
    buildGraph(options: IGraphOptions): void {
        let waterMark: any = null;
        // Initiate the chart

        this.chart = Highcharts.mapChart({
            chart: {
                renderTo: options.container,
                map: worldMap as any,
                proj4: proj4,
                backgroundColor: "#e2edf6",
                style: {
                    fontFamily: "Montserrat",
                },
                spacing: [0, 0, 0, 0],
                events: {
                    load: function (a) {
                        if (a.target) {
                            const width = a.target["chartWidth"],
                                height = a.target["chartHeight"];
                            if (waterMark) {
                                waterMark.element.remove();
                                waterMark.addClass("image");
                            }
                            waterMark = this.renderer.image(UserEndPoint.StaticUrls.NOTE_IMAGE, 40, 5, 380, 60)
                                .addClass("bdp-note-mark").add();
                        }
                    },
                    beforePrint: function (event: any) {
                        if (event.target) {
                            const width = event.target["chartWidth"],
                                height = event.target["chartHeight"];
                            if (waterMark) {
                                waterMark.element.remove();
                                waterMark.addClass("image");
                            }
                            waterMark = this.renderer
                                .image(UserEndPoint.StaticUrls.WATERMARK_IMAGE, (width - 270) / 2, (height - 90) / 2, 270, 90)
                                .addClass("bdp-water-mark").add();
                        }
                    },
                    afterPrint: function (event) {
                        if (waterMark) {
                            waterMark.element.remove();
                        }
                    },
                },
            },
            colors: Guidelines.ColorGuidelines.colorStack,
            exporting: {
                buttons: {
                    contextButton: {
                        theme: {
                            fill: "#ffffff00",
                        },
                        x: -6,
                        y: 6,
                    },
                },
                chartOptions: {
                    chart: {
                        events: {
                            afterPrint: function () {
                                waterMark.element.remove();
                            },
                            load: function (a) {
                                if (a.target) {
                                    const width = a.target["chartWidth"],
                                        height = a.target["chartHeight"];
                                    if (waterMark) {
                                        waterMark.element.remove();
                                        waterMark.addClass("image");
                                    }
                                    waterMark = this.renderer
                                        .image(
                                            UserEndPoint.StaticUrls.WATERMARK_IMAGE, (width - 270) / 2, (height - 90) / 2, 270, 90
                                        ).addClass("bdp-water-mark").add();
                                }
                            },
                        },
                    },

                },
            },

            title: {
                text:
                    '<h6 class="bdp-map-heading p-mb-0">' +
                    options.data.graphTitle +
                    "</h6>",
                align: "left",
                useHTML: true,
            },
            navigation: {
                // menuItemHoverStyle: { background: "#2d74ff", color: "#ffffff" },

            },
            subtitle: {
                text:
                    "<span class='bdp-map-subheading'>" +
                    options.data.subTitle +
                    "</span>",
                align: "left",
                useHTML: true,
            },
            mapNavigation: {
                enabled: true,
                buttonOptions: {
                    style: {
                        fontSize: "18px",
                    },
                    alignTo: "spacingBox",
                    verticalAlign: "top",
                    x: 6,

                },
                buttons: {
                    zoomIn: {
                        x: 10,
                        y: 10,
                    },
                    zoomOut: {
                        x: 10,
                        y: 38,
                    }
                }

            },
            legend: {
                enabled: false,
            },
            colorAxis: {
                min: 0,
            },
            tooltip: {
                style: {
                    textAlign: "center",
                },
                useHTML: true,
                formatter: options.data.tooltip,
            },
            plotOptions: {
                mappoint: {
                    states: {
                        inactive: {
                            opacity: 1
                        }
                    },
                    color: "red",
                    cluster: {
                        enabled: true,
                        allowOverlap: false,
                        animation: {
                            duration: 450,
                        },
                        layoutAlgorithm: {
                            type: "grid",
                            gridSize: 70,
                        },
                        zones: [
                            {
                                from: 1,
                                to: 10,
                                marker: {
                                    radius: 13,
                                    fillColor: "#2d74ff",
                                },
                            },
                            {
                                from: 11,
                                to: 20,
                                marker: {
                                    radius: 15,
                                    fillColor: "#2d74ff",
                                },
                            },
                            {
                                from: 21,
                                to: 50,
                                marker: {
                                    radius: 18,
                                    fillColor: "#2d74ff",
                                },
                            },
                            {
                                from: 51,
                                to: 100,
                                marker: {
                                    radius: 21,
                                    fillColor: "#2d74ff",
                                },
                            },
                        ],
                    },
                },
            },
            series: [
                {
                    name: "Port Congestion",
                    states: {
                        hover: {
                            color: "#BADA55",
                        },
                    },
                    dataLabels: {
                        enabled: false,
                        format: "{point.name}",
                        style: {
                            fontWeight: "lighter",
                        },
                    },
                    allAreas: true,
                    nullColor: "#fff",
                    color: "#fff",
                } as Highcharts.SeriesMapOptions,

                //  {
                //     type: "mappoint",
                //     data: [
                //         { latitude: -31.095881825671725, lon: -59.407572021304475 },
                //         { latitude: -83.97882017833302, lon: -72.65055041072554 },
                //         { latitude: -54.42982024551133, lon: 2.8246040493873164 },
                //         { latitude: -84.96318818879007, lon: -3.4029153210047025 },
                //         { latitude: -82.758731701365, lon: 9.8063659223873 },
                //         { latitude: -67.97671648884725, lon: 82.15413844678174 }
                //     ]
                // }
            ],
            credits: {
                enabled: false,
            },
        });
        if (options.data.mapData.length) {
            this.chart.addSeries({
                id: "bdpPortConnectionLine",
                name: "pod to poa",
                type: "mapline",
                lineWidth: 2,
                color: "#2d74ff",
                dashStyle: "ShortDash",
                data: [
                    {
                        id: "bdpMapLine",
                        path: this.pointsToPath(
                            this.chart.get(options.data.mapData[0].id),
                            this.chart.get(options.data.mapData[1].id)
                        ),
                        color: "#2d74ff",
                    },
                ],
            });
        }
    }

    pointsToPath(from, to, invertArc = true) {
        var arcPointX = (from.x + to.x) / (invertArc ? 2.4 : 1.6),
            arcPointY = (from.y + to.y) / (invertArc ? 2.4 : 1.6);
        return ("M" + from.x + "," + from.y + "Q" + arcPointX + " " + arcPointY + "," + to.x + " " + to.y);
    }
}
